import { useLanguage } from '../hooks/useLanguage'

export const EVENT_LABELS: Record<string, { zh: string; en: string }> = {
  defi: { zh: 'DeFi', en: 'DeFi' },
  stablecoin: { zh: '稳定币', en: 'Stablecoins' },
  rwa: { zh: 'RWA', en: 'RWA' },
  gamefi: { zh: 'GameFi', en: 'GameFi' },
  nft: { zh: 'NFT', en: 'NFT' },
  ai_crypto: { zh: 'AI × Crypto', en: 'AI × Crypto' },
  infrastructure: { zh: '基础设施', en: 'Infrastructure' },
  regulation_policy: { zh: '监管与政策', en: 'Regulation & Policy' },
  governance: { zh: '治理', en: 'Governance' },
  socialfi_creator: { zh: 'SocialFi 与创作者', en: 'SocialFi & Creator' },
  meme_culture: { zh: 'Meme', en: 'Meme' },
  multi_narrative: { zh: '综合', en: 'General' },
  networking: { zh: '行业交流', en: 'Networking' },
  investment_fundraising: { zh: '投资与融资', en: 'Investment & Fundraising' },
  party: { zh: '派对', en: 'Party' },
  general_web3: { zh: '综合', en: 'General' },
  bitcoin: { zh: 'Bitcoin', en: 'Bitcoin' },
  markets_trading: { zh: '市场与支付', en: 'Markets & Payments' },
  payments: { zh: '市场与支付', en: 'Markets & Payments' },
  privacy_identity: { zh: '隐私与身份', en: 'Privacy & Identity' },
}

export function EventLabelBadge({ eventLabel }: { eventLabel?: string }) {
  const { lang } = useLanguage()
  const label = eventLabel ? EVENT_LABELS[eventLabel] : undefined
  if (!label) return null

  return (
    <span className="inline-flex rounded-full bg-blue-50 px-2 py-0.5 text-[10px] font-semibold text-blue-700 dark:bg-blue-950/40 dark:text-blue-300">
      {label[lang]}
    </span>
  )
}
